export enum LineNumberType {
  PAGE = 'page',
  CONTINUITY = 'continuity'
}
